export const qcPalette = {
  ink: '#1B2230',
  inkSoft: '#3A4352',
  muted: '#5B6576',
  border: '#E3E6EB',
  borderStrong: '#D5DAE1',
  subtle: '#F6F7F9',
  sunken: '#EEF0F4',
  navy: '#1E2B4A',
  verified: '#2551C6',
  verifiedSoft: '#EDF1FB',
  verifiedLine: '#BFCCF0',
  flagged: '#D9640F',
  flaggedInk: '#A3400A',
  flaggedSoft: '#FFF1E8',
  flaggedLine: '#EBB48F',
  mismatchInk: '#7A4E00',
  mismatchSoft: '#FFF4D6',
  mismatchLine: '#E2A93B',
  remaining: '#C9CED6',
};

export const qcEyebrow = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.08em',
  color: qcPalette.muted,
  textTransform: 'uppercase' as const,
};

export const qcHiddenScrollbar = {
  scrollbarWidth: 'none' as const,
  msOverflowStyle: 'none' as const,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};
